// extracted by mini-css-extract-plugin
module.exports = {"flex":"Navbar_flex__yZ8hE","main":"Navbar_main__TNJ0H","img":"Navbar_img__OQ-DV","margin":"Navbar_margin__1KZfq","left":"Navbar_left__295tS","width":"Navbar_width__2vQ40"};